import React from 'react'

export default function InjectProps (props) {

  const {
    children,
    injectedProps = (child) => {}
  } = props

  // Avoid issues with rendering the parents children
  const originalProps = Object.assign({}, props)
  delete originalProps.children

  return React.Children.map(children, child => (
    React.cloneElement(child, {
      ...originalProps, // Add parent props
      ...injectedProps(child) // Add injected props
    })
  ))
}
